import { PayloadAction, createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { ApiState } from '../constants/enums';
import coreTaxDetailsServices from '../services/coreTaxDetailsServices';

import {
    ICountries,
    ICountriesRepsonse,
    IRegions,
    IRegionsRepsonse,
    ISelectedCoreTaxData,
    ISubRegions,
    ISubRegionsRepsonse,
    ITaxNames,
    ICalcBasis,
    ICalcBasisResponse,
    ITaxNameResponse,
    IDescriptiveTextResponse,
    IInsurancePartiesResponse,
    ILegislationId,
    ICoInsuranceId,
    ITaxPointId,
    IInsuranceParty,
    ISelectedCoreTaxRateData,
    ICoreTaxCreateRequest,
    ICoreTaxCreateResponse,
    ICoreTaxRateCreateRequest,
    ICoreTaxRateCreateResponse,
    ICoreTaxDetailsResponse,
    ICoreTaxUpdateRequest,
    ICoreTaxUpdateResponse,
} from '../types/rate.type';
import _ from 'lodash';
// import _ from 'lodash';

export interface CoreTaxDetailsState {
    apiState: {
        getCountries: ApiState;
        getRegions: ApiState;
        getSubRegions: ApiState;
        getTaxNames: ApiState;
        getCalcBasis: ApiState;
        getDescriptiveText: ApiState;
        getInsuranceParty: ApiState;
        saveCoreTaxes: ApiState;
        saveCoreTaxRates: ApiState;
        getCoreTaxDetailsByID: ApiState;
        updateCoreTaxes: ApiState;
    };
    countries: ICountries[];
    regions: IRegions[];
    subregions: ISubRegions[];
    taxnames: ITaxNames[];
    calcbasis: ICalcBasis[];
    legislationid: ILegislationId[];
    coinsuranceid: ICoInsuranceId[];
    taxpointid: ITaxPointId[];
    coretaxId: number;
    coretaxRateId: number;
    taxDetailsUpdateMessage: string;
    admittedbornebyid: IInsuranceParty[];
    admittedsettledbyid: IInsuranceParty[];
    nonadmittedbornebyid: IInsuranceParty[];
    nonadmittedsettledbyid: IInsuranceParty[];
    coretaxDetailsByID: ICoreTaxDetailsResponse;
    currentCoreTaxData: ISelectedCoreTaxData;
    currentCoreTaxRateData: ISelectedCoreTaxRateData;
    resetCoreTaxComponent: boolean;
    selectedReferenceLegislation: string;
    errorMessage: string;
}

export const initialCoreTaxData = {
    selectedCountry: '',
    selectedRegion: '',
    selectedSubRegion: '',
    selectedTaxName: '',
    selectedCalcBasis: '',
    selectedLegislationId: '',
    selectedCoInsuranceId: '',
    selectedTaxPointId: '',
    selectedComments: '',
};

export const initialCoreTaxRateData = {
    selectedResidentRate: '',
    selectedResidentRateType: '',
    selectedCrossBorderRate: '',
    selectedCrossBorderRateType: '',
    selectedResidentPaidBy: '',
    selectedResidentAdministeredBy: '',
    selectedCrossBorderPaidBy: '',
    selectedCrossBorderAdministeredBy: '',
    selectedRateStartDate: '',
    selectedRateEndDate: '',
    selectedTaxPointId: '',
};

export const initialCoreTaxDetailsData = {
    coreTaxId: 0,
    countryCode: '',
    countryName: '',
    regionName: '',
    subRegionName: '',
    taxName: '',
    calculationBasis: '',
    residentRate: '',
    residentRateType: '',
    crossBorderRate: '',
    crossBorderRateType: '',
    rateStartDate: '',
    rateEndDate: '',
    residentPaidBy: '',
    residentAdministeredBy: '',
    crossBorderPaidBy: '',
    crossBorderAdministeredBy: '',
    comments: '',
    referenceLegislationId: '',
};

export const taxPayload: ICoreTaxCreateRequest = {
    currencyCode: '',
    countryCode: '',
    regionId: '',
    subRegionId: '',
    taxNameId: '',
    calculationBasisId: '',
    legislationId: '',
    coInsuranceId: '',
    comments: '',
    taxPointId: '',
};

export const taxUpdatePayload: ICoreTaxUpdateRequest = {
    coreTaxId: '',
    currencyCode: '',
    countryCode: '',
    regionId: '',
    subRegionId: '',
    taxNameId: '',
    calculationBasisId: '',
    legislationId: '',
    coInsuranceId: '',
    comments: '',
    isDeleted: false,
    taxPointId: '',
};

export const taxRatePayload = {
    coreTaxId: '',
    residentRate: '',
    residentRateType: '',
    crossBorderRate: '',
    crossBorderRateType: '',
    residentPaidBy: '',
    residentAdministeredBy: '',
    crossBorderPaidBy: '',
    crossBorderAdministeredBy: '',
    fosRate: '0',
    fosRateType: 'PERCENTAGE',
    fosPaidBy: '12',
    fosAdministeredBy: '12',
    lloydsRate: '0',
    lloydsRateType: 'PERCENTAGE',
    lloydsPaidBy: '12',
    lloydsAdministeredBy: '12',
    rateStartDate: '',
    rateEndDate: '',
    taxPointId: '',
};

export const intitialCountryData: ICountries[] = [
    {
        countryCode: '',
        countryName: '',
        ISO2Code: '',
        businessRegion: '',
    },
];

export const intitialRegionData: IRegions[] = [
    {
        regionId: '',
        regionName: '',
    },
];

export const intitialSubRegionData: ISubRegions[] = [
    {
        subRegionId: '',
        subRegionName: '',
    },
];

export const intitialTaxNameData: ITaxNames[] = [
    {
        taxNameId: '',
        taxName: '',
    },
];

export const intitialCalcBasis: ICalcBasis[] = [
    {
        calcBasisId: '',
        calcBasisName: '',
        calcBasisDesc: '',
    },
];

export const intitialLegislationId: ILegislationId[] = [
    {
        descriptiveTextId: '',
        descriptiveTextType: '',
        descriptiveText: '',
    },
];

export const intitialCoInsuranceId: ICoInsuranceId[] = [
    {
        descriptiveTextId: '',
        descriptiveTextType: '',
        descriptiveText: '',
    },
];

export const intitialTaxPointId: ITaxPointId[] = [
    {
        descriptiveTextId: '',
        descriptiveTextType: '',
        descriptiveText: '',
    },
];

export const intitialAdmittedBorneByID: IInsuranceParty[] = [
    {
        insPartyId: '',
        insPartyName: '',
        insPartyDescription: '',
    },
];

export const intitialAdmittedSettledByID: IInsuranceParty[] = [
    {
        insPartyId: '',
        insPartyName: '',
        insPartyDescription: '',
    },
];

export const intitialNonAdmittedBorneByID: IInsuranceParty[] = [
    {
        insPartyId: '',
        insPartyName: '',
        insPartyDescription: '',
    },
];

export const intitialNonAdmittedSettledByID: IInsuranceParty[] = [
    {
        insPartyId: '',
        insPartyName: '',
        insPartyDescription: '',
    },
];

export const initialState: CoreTaxDetailsState = {
    apiState: {
        getCountries: ApiState.NOT_STARTED,
        getRegions: ApiState.NOT_STARTED,
        getSubRegions: ApiState.NOT_STARTED,
        getTaxNames: ApiState.NOT_STARTED,
        getCalcBasis: ApiState.NOT_STARTED,
        getDescriptiveText: ApiState.NOT_STARTED,
        getInsuranceParty: ApiState.NOT_STARTED,
        saveCoreTaxes: ApiState.NOT_STARTED,
        saveCoreTaxRates: ApiState.NOT_STARTED,
        getCoreTaxDetailsByID: ApiState.NOT_STARTED,
        updateCoreTaxes: ApiState.NOT_STARTED,
    },
    countries: [],
    regions: [],
    subregions: [],
    taxnames: [],
    calcbasis: [],
    legislationid: [],
    coinsuranceid: [],
    taxpointid: [],
    coretaxId: 0,
    coretaxRateId: 0,
    taxDetailsUpdateMessage: '',
    admittedbornebyid: [],
    admittedsettledbyid: [],
    nonadmittedbornebyid: [],
    nonadmittedsettledbyid: [],
    coretaxDetailsByID: { ...initialCoreTaxDetailsData },
    currentCoreTaxData: { ...initialCoreTaxData },
    currentCoreTaxRateData: { ...initialCoreTaxRateData },
    resetCoreTaxComponent: false,
    selectedReferenceLegislation: '',
    errorMessage: '',
};

export type SelectedCountryPayload = {
    code: string;
    updateRequest: boolean;
};

export type SelectedRegionPayload = {
    code: string;
    updateRequest: boolean;
};

export type SelectedSubRegionPayload = {
    code: string;
    updateRequest: boolean;
};

export type SelectedTaxNamePayload = {
    code: string;
    updateRequest: boolean;
};

export type SelectedCalcBasisPayload = {
    code: string;
    updateRequest: boolean;
};

export type SelectedLegislationPayLoad = {
    code: string;
    updateRequest: boolean;
};

export type SelectedCoInsurancePayLoad = {
    code: string;
    updateRequest: boolean;
};

export type SelectedTaxPointPayLoad = {
    code: string;
    updateRequest: boolean;
};

export type SelectedAdmittedBorneByPayLoad = {
    code: string;
};

export type SelectedAdmittedSettledByPayLoad = {
    code: string;
};

export type SelectedNonAdmittedSettledByPayLoad = {
    code: string;
};

export type SelectedNonAdmittedBorneByPayLoad = {
    code: string;
};

export type SelectedRateStartDatePayload = {
    code: string;
};

export type SelectedRateEndDatePayload = {
    code: string;
};

export type SelectedAdmittedRatePayload = {
    code: string;
};

export type SelectedAdmittedRateTypePayload = {
    code: string;
};

export type SelectedNonAdmittedRatePayload = {
    code: string;
};

export type SelectedNonAdmittedRateTypePayload = {
    code: string;
};

export type SelectedCommentsPayload = {
    code: string;
    updateRequest: boolean;
};

export type SelectedCoreTaxIDPayload = {
    code: string;
};

export const getCountries = createAsyncThunk<ICountriesRepsonse>('core-tax-details/get-countries', async () => {
    return coreTaxDetailsServices.getCountries().then((res) => res);
});

export const getRegions = createAsyncThunk<IRegionsRepsonse, { code: string }>(
    'core-tax-details/get-regions',
    async ({ code }) => {
        return coreTaxDetailsServices.getRegions([code]).then((res) => res);
    },
);

export const getSubRegions = createAsyncThunk<ISubRegionsRepsonse, { code: string }>(
    'core-tax-details/get-sub-regions',
    async ({ code }) => {
        return coreTaxDetailsServices.getSubRegions([code]).then((res) => res);
    },
);

export const getTaxNames = createAsyncThunk<ITaxNameResponse>('core-tax-details/get-tax-names', async () => {
    return coreTaxDetailsServices.getTaxNames().then((res) => res);
});

export const getCalcBasis = createAsyncThunk<ICalcBasisResponse>('core-tax-details/get-calc-basis', async () => {
    return coreTaxDetailsServices.getCalcBasis().then((res) => res);
});

export const getDescriptiveText = createAsyncThunk<IDescriptiveTextResponse, { searchText: string; textType: string }>(
    'core-tax-details/get-descriptive-text',
    async ({ searchText, textType }) => {
        return coreTaxDetailsServices.getDescriptiveTextResponse(searchText, textType).then((res) => res);
    },
);

export const getInsuranceParty = createAsyncThunk<IInsurancePartiesResponse, { insurancePartyType: string }>(
    'core-tax-details/get-insurance-party',
    async () => {
        return coreTaxDetailsServices.getInsurancePartiesResponse().then((res) => res);
    },
);

export const saveCoreTaxes = createAsyncThunk<ICoreTaxCreateResponse>('core-tax-details/save-core-taxes', async () => {
    var taxPayloadRequest: ICoreTaxCreateRequest[] = [];
    taxPayloadRequest.push(taxPayload);
    return coreTaxDetailsServices.saveCoreTaxes(taxPayloadRequest).then((res) => res);
});

export const saveCoreTaxRates = createAsyncThunk<ICoreTaxRateCreateResponse>(
    'core-tax-details/save-core-tax-rates',
    async () => {
        var taxRatePayloadRequest: ICoreTaxRateCreateRequest[] = [];
        taxRatePayloadRequest.push(taxRatePayload);
        return coreTaxDetailsServices.saveCoreTaxRates(taxRatePayloadRequest).then((res) => res);
    },
);

export const getCoreTaxesByID = createAsyncThunk<ICoreTaxDetailsResponse, { id: string }>(
    'core-tax-details/get-core-taxes-by-id',
    async ({ id }) => {
        return coreTaxDetailsServices.getCoreTaxDetailsByID(id).then((res) => res);
    },
);

export const updateCoreTaxes = createAsyncThunk<ICoreTaxUpdateResponse>(
    'core-tax-details/update-core-taxes',
    async () => {
        var taxUpdatePayloadRequest: ICoreTaxUpdateRequest[] = [];
        taxUpdatePayloadRequest.push(taxUpdatePayload);
        return coreTaxDetailsServices.updateCoreTaxDetails(taxUpdatePayloadRequest).then((res) => res);
    },
);

export const deleteCoreTaxes = createAsyncThunk<ICoreTaxUpdateResponse>(
    'core-tax-details/delete-core-taxes',
    async () => {
        var taxUpdatePayloadRequest: ICoreTaxUpdateRequest[] = [];
        taxUpdatePayloadRequest.push(taxUpdatePayload);
        return coreTaxDetailsServices.updateCoreTaxDetails(taxUpdatePayloadRequest).then((res) => res);
    },
);

const coreTaxDetailsSlice = createSlice({
    name: 'core-tax-details',
    initialState,
    extraReducers(builder) {
        builder
            .addCase(getCountries.pending, (state) => {
                state.apiState.getCountries = ApiState.PENDING;
            })
            .addCase(getCountries.fulfilled, (state, action: PayloadAction<ICountriesRepsonse>) => {
                state.countries = intitialCountryData.concat(state.countries);
                state.countries = state.countries.concat(action.payload.data.countries);
                state.apiState.getCountries = ApiState.FULFILLED;
            })
            .addCase(getCountries.rejected, (state) => {
                state.apiState.getCountries = ApiState.REJECTED;
            })
            .addCase(getRegions.pending, (state) => {
                state.apiState.getRegions = ApiState.PENDING;
            })
            .addCase(getRegions.fulfilled, (state, action) => {
                state.regions = [];
                state.regions = intitialRegionData.concat(state.regions);
                state.regions = state.regions.concat(action.payload.data.countries[0].regions);
                state.apiState.getRegions = ApiState.FULFILLED;
            })
            .addCase(getRegions.rejected, (state) => {
                if (state.regions.length > 0) state.regions = [];
                state.apiState.getRegions = ApiState.REJECTED;
            })
            .addCase(getSubRegions.pending, (state) => {
                state.apiState.getSubRegions = ApiState.PENDING;
            })
            .addCase(getSubRegions.fulfilled, (state, action) => {
                state.subregions = [];
                state.subregions = intitialSubRegionData.concat(state.subregions);
                state.subregions = state.subregions.concat(action.payload.data.regions[0].subRegions);
                state.apiState.getSubRegions = ApiState.FULFILLED;
            })
            .addCase(getSubRegions.rejected, (state) => {
                if (state.subregions.length > 0) state.subregions = [];
                state.apiState.getSubRegions = ApiState.REJECTED;
            })
            .addCase(getTaxNames.pending, (state) => {
                state.apiState.getTaxNames = ApiState.PENDING;
            })
            .addCase(getTaxNames.fulfilled, (state, action) => {
                state.taxnames = [];
                state.taxnames = intitialTaxNameData.concat(state.taxnames);
                state.taxnames = state.taxnames.concat(action.payload.data.taxNames);
                state.apiState.getTaxNames = ApiState.FULFILLED;
            })
            .addCase(getTaxNames.rejected, (state) => {
                if (state.taxnames.length > 0) state.taxnames = [];
                state.apiState.getTaxNames = ApiState.REJECTED;
            })
            .addCase(getCalcBasis.pending, (state) => {
                state.apiState.getCalcBasis = ApiState.PENDING;
            })
            .addCase(getCalcBasis.fulfilled, (state, action) => {
                state.calcbasis = [];
                state.calcbasis = intitialCalcBasis.concat(state.calcbasis);
                state.calcbasis = state.calcbasis.concat(action.payload.data.calcBasis);
                state.apiState.getCalcBasis = ApiState.FULFILLED;
            })
            .addCase(getCalcBasis.rejected, (state) => {
                if (state.calcbasis.length > 0) state.calcbasis = [];
                state.apiState.getCalcBasis = ApiState.REJECTED;
            })
            .addCase(getDescriptiveText.pending, (state) => {
                state.apiState.getDescriptiveText = ApiState.PENDING;
            })
            .addCase(getDescriptiveText.fulfilled, (state, action) => {
                switch (action.meta.arg.textType) {
                    case 'LEGIS':
                        state.legislationid = [];
                        state.legislationid = intitialLegislationId.concat(state.legislationid);
                        state.legislationid = state.legislationid.concat(action.payload.data.descriptiveTexts);
                        state.apiState.getDescriptiveText = ApiState.FULFILLED;
                        break;
                    case 'COINS':
                        state.coinsuranceid = [];
                        state.coinsuranceid = intitialCoInsuranceId.concat(state.coinsuranceid);
                        state.coinsuranceid = state.coinsuranceid.concat(action.payload.data.descriptiveTexts);
                        state.apiState.getDescriptiveText = ApiState.FULFILLED;
                        break;
                    case 'TAXPT':
                        state.taxpointid = [];
                        state.taxpointid = intitialTaxPointId.concat(state.taxpointid);
                        state.taxpointid = state.taxpointid.concat(action.payload.data.descriptiveTexts);
                        state.apiState.getDescriptiveText = ApiState.FULFILLED;
                        break;
                    default:
                        state.legislationid = [];
                        state.taxpointid = [];
                        state.coinsuranceid = [];
                        state.apiState.getDescriptiveText = ApiState.REJECTED;
                        break;
                }
            })
            .addCase(getDescriptiveText.rejected, (state) => {
                if (state.legislationid.length > 0) state.legislationid = [];
                if (state.taxpointid.length > 0) state.taxpointid = [];
                if (state.coinsuranceid.length > 0) state.coinsuranceid = [];
                state.apiState.getDescriptiveText = ApiState.REJECTED;
            })
            .addCase(getInsuranceParty.pending, (state) => {
                state.apiState.getInsuranceParty = ApiState.PENDING;
            })
            .addCase(getInsuranceParty.fulfilled, (state, action) => {
                switch (action.meta.arg.insurancePartyType) {
                    case 'AdmittedBorne':
                        state.admittedbornebyid = [];
                        state.admittedbornebyid = intitialAdmittedBorneByID.concat(state.admittedbornebyid);
                        state.admittedbornebyid = state.admittedbornebyid.concat(action.payload.data.insParties);
                        state.apiState.getInsuranceParty = ApiState.FULFILLED;
                        break;
                    case 'AdmittedSettled':
                        state.admittedsettledbyid = [];
                        state.admittedsettledbyid = intitialAdmittedSettledByID.concat(state.admittedsettledbyid);
                        state.admittedsettledbyid = state.admittedsettledbyid.concat(action.payload.data.insParties);
                        state.apiState.getInsuranceParty = ApiState.FULFILLED;
                        break;
                    case 'NonAdmittedBorne':
                        state.nonadmittedbornebyid = [];
                        state.nonadmittedbornebyid = intitialNonAdmittedBorneByID.concat(state.nonadmittedbornebyid);
                        state.nonadmittedbornebyid = state.nonadmittedbornebyid.concat(action.payload.data.insParties);
                        state.apiState.getInsuranceParty = ApiState.FULFILLED;
                        break;
                    case 'NonAdmittedSettled':
                        state.nonadmittedsettledbyid = [];
                        state.nonadmittedsettledbyid = intitialNonAdmittedSettledByID.concat(
                            state.nonadmittedsettledbyid,
                        );
                        state.nonadmittedsettledbyid = state.nonadmittedsettledbyid.concat(
                            action.payload.data.insParties,
                        );
                        state.apiState.getInsuranceParty = ApiState.FULFILLED;
                        break;
                    default:
                        state.admittedbornebyid = [];
                        state.admittedsettledbyid = [];
                        state.nonadmittedbornebyid = [];
                        state.nonadmittedsettledbyid = [];
                        state.apiState.getInsuranceParty = ApiState.REJECTED;
                        break;
                }
            })
            .addCase(getInsuranceParty.rejected, (state) => {
                if (state.admittedbornebyid.length > 0) state.admittedbornebyid = [];
                if (state.admittedsettledbyid.length > 0) state.admittedsettledbyid = [];
                if (state.nonadmittedbornebyid.length > 0) state.nonadmittedbornebyid = [];
                if (state.nonadmittedsettledbyid.length > 0) state.nonadmittedsettledbyid = [];
                state.apiState.getInsuranceParty = ApiState.REJECTED;
            })
            .addCase(saveCoreTaxes.pending, (state) => {
                state.apiState.saveCoreTaxes = ApiState.PENDING;
            })
            .addCase(saveCoreTaxes.fulfilled, (state, action) => {
                state.coretaxId = action.payload.data.coreTaxIds[0];
                taxRatePayload.coreTaxId = state.coretaxId.toString();
                state.apiState.saveCoreTaxes = ApiState.FULFILLED;
            })
            .addCase(saveCoreTaxes.rejected, (state, action) => {
                state.coretaxId = 0;
                state.errorMessage = action.error.message || '';
                state.apiState.saveCoreTaxes = ApiState.REJECTED;
            })
            .addCase(saveCoreTaxRates.pending, (state) => {
                state.apiState.saveCoreTaxRates = ApiState.PENDING;
            })
            .addCase(saveCoreTaxRates.fulfilled, (state, action) => {
                state.coretaxRateId = action.payload.data.coreTaxRateIds[0];
                state.apiState.saveCoreTaxRates = ApiState.FULFILLED;
            })
            .addCase(saveCoreTaxRates.rejected, (state, action) => {
                state.coretaxRateId = 0;
                state.errorMessage = action.error.message || '';
                state.apiState.saveCoreTaxRates = ApiState.REJECTED;
            })
            .addCase(getCoreTaxesByID.pending, (state) => {
                state.apiState.getCoreTaxDetailsByID = ApiState.PENDING;
            })
            .addCase(getCoreTaxesByID.fulfilled, (state, action) => {
                state.coretaxDetailsByID = action.payload;
                state.apiState.getCoreTaxDetailsByID = ApiState.FULFILLED;
            })
            .addCase(getCoreTaxesByID.rejected, (state, action) => {
                state.coretaxDetailsByID = { ...initialCoreTaxDetailsData };
                state.errorMessage = action.error.message || '';
                state.apiState.getCoreTaxDetailsByID = ApiState.REJECTED;
            })
            .addCase(updateCoreTaxes.pending, (state) => {
                state.apiState.updateCoreTaxes = ApiState.PENDING;
            })
            .addCase(updateCoreTaxes.fulfilled, (state, action) => {
                state.taxDetailsUpdateMessage = action.payload.data.message;
                state.apiState.updateCoreTaxes = ApiState.FULFILLED;
            })
            .addCase(updateCoreTaxes.rejected, (state, action) => {
                state.taxDetailsUpdateMessage = '';
                state.errorMessage = action.error.message || '';
                state.apiState.updateCoreTaxes = ApiState.REJECTED;
            });
    },
    reducers: {
        setSelectedCountry(state, action: PayloadAction<SelectedCountryPayload>) {
            state.currentCoreTaxData.selectedCountry = action.payload.code;
             if (!action.payload.updateRequest) {
                taxPayload.countryCode = action.payload.code;
                taxPayload.currencyCode = 'EUR';
            }
            else taxUpdatePayload.countryCode = action.payload.code;
            state.currentCoreTaxData.selectedRegion = '';
            state.currentCoreTaxData.selectedSubRegion = '';
            state.regions = [];
        },

        setSelectedRegion(state, action: PayloadAction<SelectedRegionPayload>) {
            state.currentCoreTaxData.selectedRegion = action.payload.code;
            if (!action.payload.updateRequest) {
                taxPayload.regionId = action.payload.code;
                taxPayload.subRegionId = '';
                taxPayload.currencyCode = 'ARS';
            } else {
                taxUpdatePayload.regionId = action.payload.code;
                taxUpdatePayload.subRegionId = '';
                taxUpdatePayload.currencyCode = 'ARS';
            }
            state.currentCoreTaxData.selectedSubRegion = '';
            state.subregions = [];
        },
        setSelectedSubRegion(state, action: PayloadAction<SelectedSubRegionPayload>) {
            state.currentCoreTaxData.selectedSubRegion = action.payload.code;
            if (!action.payload.updateRequest) taxPayload.subRegionId = action.payload.code;
            else taxUpdatePayload.subRegionId = action.payload.code;
        },
        setSelectedTaxName(state, action: PayloadAction<SelectedTaxNamePayload>) {
            state.currentCoreTaxData.selectedTaxName = action.payload.code;
            if (!action.payload.updateRequest) taxPayload.taxNameId = action.payload.code;
            else taxUpdatePayload.taxNameId = action.payload.code;
        },
        setSelectedCalcBasis(state, action: PayloadAction<SelectedCalcBasisPayload>) {
            state.currentCoreTaxData.selectedCalcBasis = action.payload.code;
            if (!action.payload.updateRequest) taxPayload.calculationBasisId = action.payload.code;
            else taxUpdatePayload.calculationBasisId = action.payload.code;
        },
        setSelectedLegislationId(state, action: PayloadAction<SelectedLegislationPayLoad>) {
            state.currentCoreTaxData.selectedLegislationId = action.payload.code;
            if (!action.payload.updateRequest) taxPayload.legislationId = action.payload.code;
            else taxUpdatePayload.legislationId = action.payload.code;
        },
        setSelectedCoInsuranceId(state, action: PayloadAction<SelectedCoInsurancePayLoad>) {
            state.currentCoreTaxData.selectedCoInsuranceId = action.payload.code;
            if (!action.payload.updateRequest) taxPayload.coInsuranceId = action.payload.code;
            else taxUpdatePayload.coInsuranceId = action.payload.code;
        },
        setSelectedTaxPointId(state, action: PayloadAction<SelectedTaxPointPayLoad>) {
            state.currentCoreTaxData.selectedTaxPointId = action.payload.code;
            state.currentCoreTaxRateData.selectedTaxPointId = action.payload.code;
            taxRatePayload.taxPointId = action.payload.code;
            if (!action.payload.updateRequest) taxPayload.taxPointId = action.payload.code;
            else taxUpdatePayload.taxPointId = action.payload.code;
        },
        setSelectedAdmittedBorneBy(state, action: PayloadAction<SelectedAdmittedBorneByPayLoad>) {
            state.currentCoreTaxRateData.selectedResidentPaidBy = action.payload.code;
            taxRatePayload.residentPaidBy = action.payload.code;
        },
        setSelectedAdmittedSettledBy(state, action: PayloadAction<SelectedAdmittedSettledByPayLoad>) {
            state.currentCoreTaxRateData.selectedResidentAdministeredBy = action.payload.code;
            taxRatePayload.residentAdministeredBy = action.payload.code;
        },
        setSelectedNonAdmittedBorneBy(state, action: PayloadAction<SelectedNonAdmittedBorneByPayLoad>) {
            state.currentCoreTaxRateData.selectedCrossBorderPaidBy = action.payload.code;
            taxRatePayload.crossBorderPaidBy = action.payload.code;
        },
        setSelectedNonAdmittedSettledBy(state, action: PayloadAction<SelectedNonAdmittedSettledByPayLoad>) {
            state.currentCoreTaxRateData.selectedCrossBorderAdministeredBy = action.payload.code;
            taxRatePayload.crossBorderAdministeredBy = action.payload.code;
        },
        setSelectedRateStartDate(state, action: PayloadAction<SelectedRateStartDatePayload>) {
            state.currentCoreTaxRateData.selectedRateStartDate = action.payload.code;
            taxRatePayload.rateStartDate = action.payload.code;
        },
        setSelectedRateEndDate(state, action: PayloadAction<SelectedRateEndDatePayload>) {
            state.currentCoreTaxRateData.selectedRateEndDate = action.payload.code;
            taxRatePayload.rateEndDate = action.payload.code;
        },
        setSelectedAdmittedRate(state, action: PayloadAction<SelectedAdmittedRatePayload>) {
            state.currentCoreTaxRateData.selectedResidentRate = action.payload.code;
            taxRatePayload.residentRate = action.payload.code;
        },
        setSelectedAdmittedRateType(state, action: PayloadAction<SelectedAdmittedRateTypePayload>) {
            state.currentCoreTaxRateData.selectedResidentRateType = action.payload.code;
            taxRatePayload.residentRateType = action.payload.code;
        },
        setSelectedNonAdmittedRate(state, action: PayloadAction<SelectedNonAdmittedRatePayload>) {
            state.currentCoreTaxRateData.selectedCrossBorderRate = action.payload.code;
            taxRatePayload.crossBorderRate = action.payload.code;
        },
        setSelectedNonAdmittedRateType(state, action: PayloadAction<SelectedNonAdmittedRateTypePayload>) {
            state.currentCoreTaxRateData.selectedCrossBorderRateType = action.payload.code;
            taxRatePayload.crossBorderRateType = action.payload.code;
        },
        setSelectedComments(state, action: PayloadAction<SelectedCommentsPayload>) {
            state.currentCoreTaxData.selectedComments = action.payload.code;
            if (!action.payload.updateRequest) taxPayload.comments = action.payload.code;
            else taxUpdatePayload.comments = action.payload.code;
        },
        setCoreTaxIDForUpdate(state, action: PayloadAction<SelectedCoreTaxIDPayload>) {
            taxUpdatePayload.coreTaxId = action.payload.code;
        },
        resetModalFlags(state){
            state.coretaxId = 0;
            state.coretaxRateId = 0;
            state.taxDetailsUpdateMessage = '';
            state.errorMessage = '';
        },
        resetCoreTaxDetails(state){
            state.currentCoreTaxData.selectedCalcBasis = '';
            state.currentCoreTaxData.selectedCoInsuranceId = '';
            state.currentCoreTaxData.selectedComments = '';
            state.currentCoreTaxData.selectedCountry = '';
            state.currentCoreTaxData.selectedLegislationId = '';
            state.currentCoreTaxData.selectedRegion = '';
            state.currentCoreTaxData.selectedSubRegion = '';
            state.currentCoreTaxData.selectedTaxName = '';
            state.currentCoreTaxData.selectedTaxPointId = '';
            state.selectedReferenceLegislation = '';
        },
        resetCoreTaxRateDetails(state){
            state.currentCoreTaxRateData.selectedCrossBorderAdministeredBy = '';
            state.currentCoreTaxRateData.selectedCrossBorderPaidBy = '';
            state.currentCoreTaxRateData.selectedCrossBorderRate = '';
            state.currentCoreTaxRateData.selectedCrossBorderRateType = '';
            state.currentCoreTaxRateData.selectedRateEndDate = '';
            state.currentCoreTaxRateData.selectedRateStartDate = '';
            state.currentCoreTaxRateData.selectedResidentAdministeredBy = '';
            state.currentCoreTaxRateData.selectedResidentPaidBy = '';
            state.currentCoreTaxRateData.selectedResidentRate = '';
            state.currentCoreTaxRateData.selectedResidentRateType = '';
        },
        resetCoreTaxDetailsByID(state){
            state.coretaxDetailsByID.calculationBasis = '';
            state.coretaxDetailsByID.comments = '';
            state.coretaxDetailsByID.coreTaxId = 0;
            state.coretaxDetailsByID.countryCode = '';
            state.coretaxDetailsByID.countryName = '';
            state.coretaxDetailsByID.crossBorderAdministeredBy = '';
            state.coretaxDetailsByID.crossBorderPaidBy = '';
            state.coretaxDetailsByID.crossBorderRate = '';
            state.coretaxDetailsByID.crossBorderRateType = '';
            state.coretaxDetailsByID.rateEndDate = '';
            state.coretaxDetailsByID.rateStartDate = '';
            state.coretaxDetailsByID.regionName = '';
            state.coretaxDetailsByID.residentAdministeredBy = '';
            state.coretaxDetailsByID.residentPaidBy = '';
            state.coretaxDetailsByID.residentRate = '';
            state.coretaxDetailsByID.residentRateType = '';
            state.coretaxDetailsByID.subRegionName = '';
            state.coretaxDetailsByID.taxName = '';

        },
        resetCoreTaxComponent(state){
            state.resetCoreTaxComponent = true;
        },
        resetTaxNames(state){
            state.taxnames = [];
        },
        resetCoInsurance(state){
            state.coinsuranceid = [];
        },
        resetTaxPoint(state){
            state.taxpointid = [];
        },
        resetReferenceLegislation(state){
            state.legislationid = [];
        },
        reloadCoreTaxComponent(state){
            state.resetCoreTaxComponent = false;
        },
        setSelectedReferenceLegislation(state, action: PayloadAction<string>){
            state.selectedReferenceLegislation = action.payload;
        },
        resetSelectedReferenceLegislation(state){
            state.selectedReferenceLegislation = '';
        },
        setCloneState(state){
            var cloneCurrentCoreTax = _.cloneDeep(state.currentCoreTaxData);
            var cloneCurrentCoreTaxRate = _.cloneDeep(state.currentCoreTaxRateData);
            // var cloneCoreTaxDetails = _.cloneDeep(state.coretaxDetailsByID);
            // console.log(cloneCurrentCoreTax);
            // console.log(cloneCurrentCoreTaxRate);
            // console.log(cloneCoreTaxDetails);
            taxPayload.calculationBasisId = cloneCurrentCoreTax.selectedCalcBasis ?? '';
            taxPayload.coInsuranceId = cloneCurrentCoreTax.selectedCoInsuranceId ?? '';
            taxPayload.comments = cloneCurrentCoreTax.selectedComments ?? '';
            taxPayload.countryCode = cloneCurrentCoreTax.selectedCountry ?? '';
            taxPayload.currencyCode = 'ARS';
            taxPayload.legislationId = cloneCurrentCoreTax.selectedLegislationId ?? '';
            taxPayload.regionId = cloneCurrentCoreTax.selectedRegion ?? '';
            taxPayload.subRegionId = cloneCurrentCoreTax.selectedSubRegion ?? '';
            taxPayload.taxNameId = cloneCurrentCoreTax.selectedTaxName ?? '';
            taxPayload.taxPointId = cloneCurrentCoreTax.selectedTaxPointId ?? '';
            taxRatePayload.crossBorderAdministeredBy = cloneCurrentCoreTaxRate.selectedCrossBorderAdministeredBy ?? '';
            taxRatePayload.crossBorderPaidBy = cloneCurrentCoreTaxRate.selectedCrossBorderPaidBy ?? '';
            taxRatePayload.crossBorderRate = cloneCurrentCoreTaxRate.selectedCrossBorderRate ?? '';
            taxRatePayload.crossBorderRateType = cloneCurrentCoreTaxRate.selectedCrossBorderRateType ?? '';
            taxRatePayload.rateStartDate = cloneCurrentCoreTaxRate.selectedRateStartDate ?? '';
            taxRatePayload.rateEndDate = cloneCurrentCoreTaxRate.selectedRateEndDate ?? '';
            taxRatePayload.residentAdministeredBy = cloneCurrentCoreTaxRate.selectedResidentAdministeredBy ?? '';
            taxRatePayload.residentPaidBy = cloneCurrentCoreTaxRate.selectedResidentPaidBy ?? '';
            taxRatePayload.residentRate = cloneCurrentCoreTaxRate.selectedResidentRate ?? '';
            taxRatePayload.residentRateType = cloneCurrentCoreTaxRate.selectedResidentRateType ?? '';
            taxRatePayload.taxPointId = cloneCurrentCoreTaxRate.selectedTaxPointId ?? '';
        },
        setDeleteState(state, action: PayloadAction<string>){
            var cloneCurrentCoreTax = _.cloneDeep(state.currentCoreTaxData);
            taxUpdatePayload.calculationBasisId = cloneCurrentCoreTax.selectedCalcBasis ?? '';
            taxUpdatePayload.coInsuranceId = cloneCurrentCoreTax.selectedCoInsuranceId ?? '';
            taxUpdatePayload.comments = cloneCurrentCoreTax.selectedComments ?? '';
            taxUpdatePayload.coreTaxId = action.payload;
            taxUpdatePayload.countryCode = cloneCurrentCoreTax.selectedCountry ?? '';
            taxUpdatePayload.currencyCode = 'ARS';
            taxUpdatePayload.isDeleted = true;
            taxUpdatePayload.legislationId = cloneCurrentCoreTax.selectedLegislationId ?? '';
            taxUpdatePayload.regionId = cloneCurrentCoreTax.selectedRegion ?? '';
            taxUpdatePayload.subRegionId = cloneCurrentCoreTax.selectedSubRegion ?? '';
            taxUpdatePayload.taxNameId = cloneCurrentCoreTax.selectedTaxName ?? '';
            taxUpdatePayload.taxPointId = cloneCurrentCoreTax.selectedTaxPointId ?? '';
        },       
    },
});

export const {
    setSelectedCountry,
    setSelectedRegion,
    setSelectedSubRegion,
    setSelectedTaxName,
    setSelectedCalcBasis,
    setSelectedLegislationId,
    setSelectedCoInsuranceId,
    setSelectedTaxPointId,
    setSelectedAdmittedBorneBy,
    setSelectedAdmittedSettledBy,
    setSelectedNonAdmittedBorneBy,
    setSelectedNonAdmittedSettledBy,
    setSelectedRateStartDate,
    setSelectedRateEndDate,
    setSelectedAdmittedRate,
    setSelectedAdmittedRateType,
    setSelectedNonAdmittedRate,
    setSelectedNonAdmittedRateType,
    setSelectedComments,
    setCoreTaxIDForUpdate,
    resetCoreTaxDetails,
    resetCoreTaxRateDetails,
    resetCoreTaxComponent,
    reloadCoreTaxComponent,
    resetCoreTaxDetailsByID,
    setSelectedReferenceLegislation,
    resetSelectedReferenceLegislation,
    setCloneState,
    setDeleteState,
    resetTaxNames,
    resetCoInsurance,
    resetTaxPoint,
    resetReferenceLegislation,
    resetModalFlags,
} = coreTaxDetailsSlice.actions;

export default coreTaxDetailsSlice.reducer;
